import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import * as Yup from "yup";
import { useFormik } from "formik";
import { addKiloleterMasterAsync } from "../../../../redux/features/kiloleter-master/addKiloleterMasterSlice";
import { useDispatch } from "react-redux";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";

const validationSchema = Yup.object().shape({
   kiloleter: Yup.string().required("Kiloleter value is required"),
});

export default function KiloleterMasterAdd() {
   const dispatch = useDispatch();

   const initialValues = {
      kiloleter: "",
   };

   const handleCompany = async (formData) => {
      dispatch(backdropLoadingAction(true));

      dispatch(
         addKiloleterMasterAsync({
            data: formData,
            done: () => {
               formik.resetForm();
               dispatch(backdropLoadingAction(false));
               toast.success("Record added successfully.");
            },
            err: () => {
               dispatch(backdropLoadingAction(false));
               //toast.error("Failed to add.");
            },
         }),
      );
   };

   const formik = useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: handleCompany,
   });

   const { getFieldProps, handleSubmit, touched, errors } = formik;

   return (
      <div>
         <BodyHeader title="Kiloleter Master" />
         <div className="p-3 shadow-lg">
            <div className="row">
               <div className="col-lg-12">
                  <div className="card card-primary">
                     <div className="card-header">
                        <h3 className="card-title">Kiloleter Master Details</h3>
                     </div>

                     <div className="card-body">
                        <div className="row">
                           <div className="col-12 col-sm-12 col-md-6">
                              <CustomInput
                                 inputType="number"
                                 require
                                 label="Kiloleter"
                                 id="kiloleter"
                                 placeholder="Enter volume"
                                 {...getFieldProps("kiloleter")}
                                 errors={touched.kiloleter && errors.kiloleter}
                                 message={errors.kiloleter}
                              />
                           </div>
                           <div className="col-lg-12 mt-3 text-center">
                              <button
                                 className="btn btn-primary px-4 py-3"
                                 type="submit"
                                 onClick={handleSubmit}
                              >
                                 <h6 className="mb-0 text-uppercase">Submit</h6>
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
